export default __webpack_public_path__ + "static/media/chatbot-image.6506609a.png";